import React from 'react';
import cn from 'classnames';
import IconTrash from '@dealroadshow/uikit-icon/IconTrash';
import IconEmail from '@dealroadshow/uikit-icon/IconEmail';
import Input from '@dealroadshow/uikit-input';
import Tooltip from '@dealroadshow/uikit-tooltip';
import { dataTableStyles } from '@dealroadshow/uikit-table/DataTable';
import { Field } from '@framework/ui/Organisms/FinalForm';
import Button, { ButtonVariantType } from '@dealroadshow/uikit-button';
import decodeSymbols from '@framework/data-helpers/string/decodeSymbols';

import styles from './speakersTable.module.scss';

export const getColumns = (fields, disabled) => {
  return [
    {
      name: 'email',
      width: '13%',
      title: 'Email',
      className: dataTableStyles.inputCol,
      cellCallback: ({ row }) => (
        <div>
          <Field
            name={ `${ row.fieldName }.email` }
            component={ Input }
            disabled={ disabled }
            placeholder="Email"
            icon={ IconEmail }
            isNarrow
            dataTest={ `emailInput${ row.fieldIndex }` }
          />
        </div>
      ),
    },
    {
      name: 'name',
      width: '12%',
      className: dataTableStyles.inputCol,
      title: 'Speaker name',
      cellCallback: ({ row }) => (
        <Field
          name={ `${ row.fieldName }.name` }
          component={ Input }
          disabled={ disabled }
          format={ (value) => decodeSymbols(value) }
          dataTest={ `nameInput${ row.fieldIndex }` }
          placeholder="Enter Name"
          isNarrow
        />
      ),
    },
    {
      name: 'actions',
      width: '10%',
      title: '',
      className: dataTableStyles.actionCol,
      cellCallback: ({ row }) => !!row.fieldIndex && (
        <Button
          className={ cn(dataTableStyles.actionItem, styles.removeBtn) }
          dataTest={ `${ row.fieldName }DeleteSpeakerButton` }
          variant={ ButtonVariantType.text }
          onClick={ () => fields.remove(row.fieldIndex) }
        >
          <Tooltip content="Delete speaker">
            <IconTrash />
          </Tooltip>
        </Button>
      ),
    },
  ];
};
